

import React from 'react';
import * as style from './style';
import ScreenClassResolver from '../../context/ScreenClassResolver';










const Visible = ({
  children,
  xs = false,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  xxl = false
}) =>
<ScreenClassResolver>
    {(screenClass) => !style.visible({
    screenClass,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl
  }) ?
  null :
  children}
  </ScreenClassResolver>;



Visible.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  xxl: false
};

export default Visible;